import React from "react";
import cx from "classnames";
import { Button } from "@picklebet/ui";
import { TrashIcon } from "@picklebet/ui";
import * as styles from "./PickSlip.module.scss";

type TrashIconButtonType = {
  onClick: () => void;
};

const TrashIconButton = ({ onClick }: TrashIconButtonType) => {
  return (
    <Button
      variant={`blurred`}
      className={cx(styles.iconButton, styles.trash)}
      onClick={onClick}
    >
      <TrashIcon />
    </Button>
  );
};

export default TrashIconButton;
